module.exports = __webpack_public_path__ + "img/horizontal_5_1_8003.bf38eac3.png";